import { confirmSignIn, signIn, signOut } from 'aws-amplify/auth'
import { ConfirmConsumerV2OrderRequest, ConsumerOrderDetails } from '../../model'
import { get, put } from './api'

const handleSignInWithOrderChallenge = async (orderToken: string, email: string) => {
    let domain = window.location.hostname

    if (domain === 'localhost') {
        domain = 'klanten-test.tibimedia.nl'
    }
    return signIn({
        username: email,
        options: {
            authFlowType: 'CUSTOM_WITHOUT_SRP',
            clientMetadata: {
                orderToken,
                domain,
                action: 'ORDER_ACCESS'
            }
        }
    })
}

const isAlreadySignedInError = (error: unknown) => {
    const name = (error as { name?: string })?.name
    return name === 'AlreadySignedInException' || name === 'UserAlreadyAuthenticatedException'
}

export const initiateOrderAuth = async (orderToken: string, email?: string) => {
    let result

    if (!email) {
        throw new Error('E-mailadres ontbreekt')
    }
    try {
        result = await handleSignInWithOrderChallenge(orderToken, email)
    } catch (error) {
        if (!isAlreadySignedInError(error)) {
            throw error
        }

        await signOut()
        result = await handleSignInWithOrderChallenge(orderToken, email)
    }

    if (!result.nextStep) {
        throw new Error('Sign-in response missing nextStep')
    }

    if (result.nextStep.signInStep !== 'CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE') {
        throw new Error(`Unexpected sign-in step: ${result.nextStep.signInStep}`)
    }

    return result
}

export const submitVerificationCode = async (otpCode: string, orderToken: string) => {
    let domain = window.location.hostname

    if (domain === 'localhost') {
        domain = 'klanten-test.tibimedia.nl'
    }

    return confirmSignIn({
        challengeResponse: otpCode,
        options: {
            clientMetadata: {
                orderToken,
                domain,
                action: 'ORDER_ACCESS'
            }
        }
    })
}

export const retrieveOrder = async (): Promise<ConsumerOrderDetails> => {
    const { data } = await get('/v2/consumer/order')
    return data
}

export const confirmOrder = async (params: ConfirmConsumerV2OrderRequest): Promise<any> => {
    const { data } = await put('/v2/consumer/order/confirm', {
        data: params
    })
    return data
}

export const catchOrderConfirmError = (error: unknown) => {
    const errorName = (error as { name?: string; __type?: string })?.name || (error as { __type?: string })?.__type

    if (errorName === 'CodeMismatchException' || errorName === 'NotAuthorizedException') {
        return 'De verificatiecode is onjuist. Controleer de code en probeer opnieuw.'
    }

    if (errorName === 'ExpiredCodeException') {
        return 'De verificatiecode is verlopen. Vraag een nieuwe code aan en probeer opnieuw.'
    }

    if (errorName === 'InvalidLambdaResponseException') {
        return 'De verificatie kon niet worden afgerond. Controleer je e-mailadres en vraag eventueel een nieuwe code aan.'
    }

    return 'Er is een fout opgetreden bij het ophalen van de opdracht. Probeer het later opnieuw.'
}
